// Entry point for esbuild bundling
// All dependencies are bundled into a single file for faster loading

// Import Turbo (replaces Turbolinks - Phase 2B Week 6)
import "@hotwired/turbo-rails"

// Import Rails UJS for remote: true links (replaces jQuery UJS)
import Rails from "@rails/ujs"
Rails.start()

// Import Bootstrap 5 (vanilla JS - no jQuery!)
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// Import SweetAlert2 for styled confirmation dialogs (jQuery-free)
import Swal from "sweetalert2"
window.Swal = Swal

// Import polyfills and utilities
import "./polyfills"
import "./mobile_check"
import "./turbo_confirm"

// Import custom Turbo Stream actions
import "./turbo_custom_actions"

// Import Turbo unauthorized handler (shows modal for 403 responses)
import "./turbo_unauthorized_handler"

// Import Stimulus controllers
import "./controllers"

// Import Trix editor and ActionText
import "trix"
import "@rails/actiontext"
